import { motion } from "framer-motion";
import { systemWhite } from "../../constants";
import { createStyledElement } from "../../../../utils/createStyledElement";

const isMobileViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 768 : false;

export const CarouselSectionContent = createStyledElement(motion.section, () => ({
  paddingBottom: 50,
  backgroundColor: isMobileViewport() ? systemWhite : "#FAFBFF",
}));

export const CarouselImage = createStyledElement("img", {
  width: "100%",
  height: 250,
  borderRadius: 8,
});

export const CarouselImageContainer = createStyledElement("div", {
  padding: "0 10px",
});
